var _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 20,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(90 7 0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16.061,
    width: 8,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(135 12 16.06)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.343,
    y: 21.718,
    width: 8,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(-135 6.343 21.718)"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxMiAyMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjEuNSIgcng9IjAuNzUiIHRyYW5zZm9ybT0icm90YXRlKDkwIDcgMCkiLz4KPHJlY3QgeD0iMTIiIHk9IjE2LjA2MDciIHdpZHRoPSI4IiBoZWlnaHQ9IjEuNSIgcng9IjAuNzUiIHRyYW5zZm9ybT0icm90YXRlKDEzNSAxMiAxNi4wNjA3KSIvPgo8cmVjdCB4PSI2LjM0MzAyIiB5PSIyMS43MTc1IiB3aWR0aD0iOCIgaGVpZ2h0PSIxLjUiIHJ4PSIwLjc1IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTM1IDYuMzQzMDIgMjEuNzE3NSkiLz4KPC9zdmc+Cg==";
export { SvgDownArrow as ReactComponent };